export default "__VITE_ASSET__BzPlt1TG__"